import { useAuth } from "@clerk/clerk-react";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import {
  CheckoutState,
  SplashPage,
  SubscriptionContext,
} from "contexts/Subscription";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddOnItemName, SubscriptionPortalFlow } from "schemas/dashboard";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import { fetcherAuth } from "./api";
import { getParams } from "./tracking";

export const useSubscription = () => {
  const navigate = useNavigate();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription, upgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);
  const { getToken } = useAuth();
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const { setErrorAlert } = useContext(AlertContext);

  const cannotUpgrade =
    (subscription?.isSubscribed &&
      (subscription?.subscription?.planName === Plans.VA_YEARLY ||
        subscription?.subscription?.planName === Plans.VA)) ||
    currentOrg?.overridePlanName;

  const handleCheckout = async (
    plan: Plans | AddOnItemName,
    pageSource?: string,
    source?: string | null,
    splashPageSource: SplashPage | null = null,
  ) => {
    const state: CheckoutState = {
      plan,
      source,
      pageSource,
      coupon: getParams("coupon"),
      splashPageSource,
    };
    if (upgradeDialogSource) {
      setOpenCheckoutDialog(state);
    } else {
      navigate(`/${routes.subscriptions}`, {
        state,
      });
    }
  };

  const handleManagePlan = async (flow?: SubscriptionPortalFlow) => {
    try {
      setCheckoutLoading(true);
      const res = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/payments/subscription/manage`,
        "POST",
        {},
        {
          flow,
        },
      );
      window.open(res.session.url, "_self");
    } catch (error) {
      setErrorAlert(error);
    } finally {
      setCheckoutLoading(false);
    }
  };

  return { handleCheckout, handleManagePlan, checkoutLoading, cannotUpgrade };
};
